// extracted by mini-css-extract-plugin
module.exports = {"share__wrapper":"styles_share__wrapper__3RK9c","row":"styles_row__2crYm","copy_link":"styles_copy_link__pDVPq"};